// removed by extract-text-webpack-plugin
module.exports = {"regularUserContact":"_7GkdEB4X2gF0XJ_jIpZlc","logo":"_1LpHH6Kdz748IyRrsp1CAe","user":"_1yNEWVQ6BjQwTQsknNFzdJ","userInfo":"_28UBCaRdEmoAC0S93HaJQm","userName":"_2QIE8sBfCtS7rP2lVstjn9","userStatus":"_3MmS5fm3m73YaJ21bJY8S_","actions":"_1vPwsk7Yowpz4gl8UtMu7W","sendMessage":"_3jveAAZwdI8mI3rQ91q_NL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/RegularUserContact/RegularUserContact.scss
// module id = 1724
// module chunks = 0